module.exports = __webpack_public_path__ + "assets/img/slat_open.fe2f0655.svg";